import React from "react";
import { useCreatClientHook } from "../../../createClient/hooks";
import TextInput from "../../../../components/inputs/input";
import PasswordInput from "../../../../components/inputs/password";

const Form = () => {
  const { onValueChange, errorState } = useCreatClientHook();
  return (
    <div className="flex flex-col gap-4 w-full py-3">
      <TextInput
        label={"Nom de l'entreprise"}
        errorState={errorState.client_name}
        onChange={onValueChange("client_name")}
      />
      <div className="flex flex-col gap-2">
        <span className="flex text-[10px]">
          L'adresse email et le mot de passe serviront d'identifiants de
          connexion pour le referant de l'entreprise sur la console client.
        </span>
        <TextInput
          label={"Email du referant"}
          errorState={errorState.referant_email}
          onChange={onValueChange("referant_email")}
        />
      </div>
      <PasswordInput
        label={"Mot de passe"}
        autoGenerate={true}
        errorState={errorState.referant_password}
        onChange={onValueChange("referant_password")}
      />
      <span className="flex font-normal text-[13px] gap-3">
        <span className="flex text-[25px]">⚠️</span>
        <span className="flex">
          Après avoir terminé le processus d'enregistrement, les identifiants de
          connexion du client lui seront automatiquement envoyés par e-mail.
        </span>
      </span>
    </div>
  );
};

export default Form;
